import {Box} from '@treatwell/ui';
import styles from './Basket.module.css';
import clsx from 'clsx';

type Props = {
  children: React.ReactElement[] | React.ReactElement;
  className?: string;
};

export const Basket = ({children, className}: Props) => {
  return (
    <Box
      className={clsx(styles.root, className)}
      data-cy="Basket"
      paddingWide="xl"
    >
      {children}
    </Box>
  );
};
